import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { PanelMenuModule } from 'primeng/panelmenu';
import { environment } from '../../../environments/environment';
import { Auth } from '../../services/auth';
import { TopbarMenu } from '../topbar-menu/topbar-menu';
import { Footer } from './footer/footer';

@Component({
  selector: 'app-logged-in',
  imports: [RouterOutlet, TopbarMenu, PanelMenuModule, Footer],
  templateUrl: './logged-in.html',
  styleUrl: './logged-in.css',
})
export class LoggedIn {
  // private timerSub?: Subscription;

  constructor(titleService: Title, private authService: Auth) {
    titleService.setTitle(environment.mainTitle);
    // authService.getCurrentUser().subscribe((user) => {
    //   if (user) {
    //     this.startSessionCountdown();
    //   } else {
    //     this.stopSessionCountdown();
    //   }
    // });
  }

  // private startSessionCountdown() {
  //   this.stopSessionCountdown();
  //   this.timerSub = interval(1000).subscribe(() => {
  //     const exp = this.authService.getTokenExpiration();
  //     if (!exp) return;
  //     const diff = exp - Date.now();
  //     if (diff <= 0) {
  //       // this.sessionWarning = 'Session expired.';
  //       this.authService.logout();
  //     } else if (diff < 60000) {
  //       // less than 1 min
  //       // this.sessionWarning = `Session expires in ${Math.ceil(
  //       //   diff / 1000
  //       // )} seconds.`;
  //     } else {
  //       // this.sessionWarning = '';
  //     }
  //   });
  // }

  // private stopSessionCountdown() {
  //   if (this.timerSub) {
  //     this.timerSub.unsubscribe();
  //     this.timerSub = undefined;
  //   }
  //   // this.sessionWarning = '';
  // }

  // ngOnDestroy() {
  //   this.stopSessionCountdown();
  // }
}
